<template>
  <div class="popup-content"  v-if="popupContent">
      <AccentHeader
        v-if="popupContent.name"
        :header="popupContent.name"
        :underline="true"
        :uppercase="false"
      />
      <p class="paragraph" v-if="popupContent.description">
        {{ popupContent.description }}
      </p>
      <dl v-if="popupContent.params || popupContent.link" class="paragraph popup-content-params">
        <template v-for="(text, id, index) in popupContent.params">
          <dt :key="'param-title' + index" v-if="text">
            {{ centrumData['course-params'][id] }}
          </dt>
          <dd class="accent" :key="'param-details' + index" v-if="text">
            {{ text }}
          </dd>
        </template>
        <template v-if="popupContent.link">
          <dt class="inline">
            {{ centrumData['course-params']['link'] }}
          </dt>
          <dd class="accent">
            <a :href="'mailto:' + popupContent.link" class="accent">
              {{ popupContent.link }}
            </a>
          </dd>
        </template>
      </dl>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AccentHeader from '@/components/AccentHeader.vue'

export default {
  name: 'PopupContentLoader',
  props: ['popupContent'],
  components: {
    AccentHeader
  },
  computed: {
    ...mapGetters([
      'centrumData'
    ])
  }
}
</script>

<style scoped lang="scss">
.popup-content {

  .paragraph {
    font-size: $font-m;

    .font-size-l & {
      font-size: ceil($font-m * 1.35);
    }
  }

  a {
    text-decoration: none;

    &:hover, &:focus {
      text-decoration: underline;
    }
  }

  &-params {
    padding: $gap-sm 0;

    dt {
      padding: $gap-sm 0 0 0;

      &.inline {
        text-transform: none;
      }
    }
  } // END .popup-content-params;

  @include screen ('md') {
    .paragraph {
      font-size: $font-s;

      .font-size-l & {
        font-size: ceil($font-s * 1.35);
      }
    }

    &-params {
      dt.inline,
      dt.inline + dd {
        display: inline-block;
        margin-right: 0.5em;
        width: auto;
      }
    } // END .popup-content-params;
  } // END @include screen ('md);

} // END .popup-content;
</style>
